module.exports = __webpack_public_path__ + "c7876fa48311460b610e895df7434d61.jpg";